
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recupera-password",
      function () {
        return require("private-next-pages/recupera-password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recupera-password"])
      });
    }
  